module.exports = __webpack_public_path__ + "img/secure.fe3e635e.png";